import React from 'react'
import styled from 'styled-components'
import Eric from './Eric'
import Henri from './Henri'
import Julieta from './Julieta'
import Juuso from './Juuso'
import Mariusz from './Mariusz'
import Matthew from './Matthew'
import Minh from './Minh'
import Nikke from './Nikke'
import Petri from './Petri'
import Santeri from './Santeri'
import Teo from './Teo'
import Tom from './Tom'
import Tuomas from './Tuomas'
import Jarno from './Jarno'
import Mark from './Mark'
import Nico from './Nico'
import Placeholder from './Placeholder'

const headshots = {
    ericAndrews: Eric,
    henriPihkala: Henri,
    julietaArenasMoran: Julieta,
    juusoTakalainen: Juuso,
    mariuszRolinski: Mariusz,
    matthewFontana: Matthew,
    minhNguyen: Minh,
    nikkeNylund: Nikke,
    petriSavolainen: Petri,
    santeriJuslenius: Santeri,
    teoGebhard: Teo,
    tomHamilton: Tom,
    tuomasKoponen: Tuomas,
    jarnoMarttila: Jarno,
    markLittle: Mark,
    nicoBurkart: Nico,
}

const UnstyledPicture = ({ alt, children, memberId, onClick, ...props }) => {
    const Headshot = headshots[memberId] || Placeholder

    return (
        <div
            {...props}
            onClick={onClick}
            onFocus={() => {}}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <div>
                <Headshot />
                {children}
            </div>
        </div>
    )
}

const Picture = styled(UnstyledPicture)`
    border-radius: 0.125rem;
    outline: 0;
    overflow: hidden;

    > div {
        position: relative;
    }
`

export default Picture
